import React from 'react';
import Box from '@mui/material/Box';
import CloseIcon from '@mui/icons-material/Close';

const CloseCircleIcon: React.FC = () => (
  <Box
    sx={{
      width: 24,
      height: 24,
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      border: '2px solid black'
    }}
  >
    <CloseIcon sx={{ color: 'black', fontSize: 18 }} />
  </Box>
);

export default CloseCircleIcon;
